document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  function getProductDataByVariantId(variantId) {
    const script = document.querySelector(
      `[data-product-data][data-variant-id="${variantId}"]`
    );
    if (!script) {
      // Fallback: cerca button con classe product_card__atc
      const button = document.querySelector(
        `button.product_card__atc[data-variant-id="${variantId}"]`
      );
      if (!button) {
        console.warn("No product data found for variantId", variantId);
        return null;
      }
      // Costruisci l'oggetto dati dal button
      const dataset = button.dataset;
      const price = parseFloat(dataset.variantPrice) || 0;
      const discount = parseFloat(dataset.variantDiscount) || 0;
      return {
        price: price,
        compare_at_price: discount > 0 ? price + discount : null,
        sku: dataset.variantSku || "",
        title: dataset.variantTitle || "",
        vendor: dataset.variantVendor || "",
        currency: window.Shopify?.currency?.active || "EUR"
      };
    }
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error("Error parsing product data for variantId", variantId, e);
      return null;
    }
  }

  function getCartValue() {
    const totalSpan = document.querySelector(".totals__subtotal-value");
    if (!totalSpan) return 0;
    // Estrae il testo, rimuove simboli di valuta e "EUR", sostituisce virgola con punto
    const text = totalSpan.textContent.trim();
    const numericValue = text
      .replace(/[€\s]/g, "")
      .replace("EUR", "")
      .replace(/\./g, "")
      .replace(",", ".");
    return parseFloat(numericValue) || 0;
  }

  function pushAddToCartEvent(variantId) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const discount = parseFloat(Math.max(0, maxPrice - finalPrice).toFixed(2));
    const itemId = productData?.sku ?? '';
    const cartData = getCartValue();
    // Recupera la quantità dall'input associato al variantId
    let quantity = 1;
    const input = document.querySelector(
      `.quantity__input[data-quantity-variant-id="${variantId}"]`
    );
    if (input && input.value) {
      quantity = parseInt(input.value, 10) || 1;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: productData.currency,
        value: cartData,
        items: [
          {
            item_name: productData.title,
            item_id: itemId,
            price: finalPrice,
            item_brand: productData.vendor,
            quantity: quantity,
            discount: discount,
          },
        ],
      },
    });
  }

  function pushRemoveFromCartEvent(variantId, quantityOverride) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;
    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const cartData = getCartValue();
    const discount = parseFloat(Math.max(0, maxPrice - finalPrice).toFixed(2));
    const itemId = productData?.sku ?? '';
    let quantity;
    if (typeof quantityOverride === "number") {
      quantity = quantityOverride;
    } else {
      // Recupera la quantità dall'input associato al variantId
      quantity = 1;
      const input = document.querySelector(
        `.quantity__input[data-quantity-variant-id="${variantId}"]`
      );
      if (input && input.value) {
        quantity = parseInt(input.value, 10) || 1;
      }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: productData.currency,
        value: cartData,
        items: [
          {
            item_name: productData.title,
            item_id: itemId,
            price: finalPrice,
            item_brand: productData.vendor,
            quantity: quantity,
            discount: discount,
          },
        ],
      },
    });
  }

  cartDrawer.addEventListener("click", function (e) {
    const plusBtn = e.target.closest(".plusAddToCartMiniCart");
    const minusBtn = e.target.closest(".minusRemoveFromMiniCart");
    const removeBtn = e.target.closest(".cart-item__remove");
    if (plusBtn && plusBtn.dataset.variantId) {
      pushAddToCartEvent(plusBtn.dataset.variantId);
    }

    if (removeBtn && removeBtn.dataset.variantId) {
      // Quando clicchi sul cestino, passa la quantità attuale dell'input
      const input = removeBtn
        .closest(".cart-item, tr.cart-item")
        ?.querySelector(".quantity__input");
      let quantity = 1;
      if (input && input.value) {
        quantity = parseInt(input.value, 10) || 1;
      }
      pushRemoveFromCartEvent(removeBtn.dataset.variantId, quantity);
    }

    if (minusBtn && minusBtn.dataset.variantId) {
      pushRemoveFromCartEvent(minusBtn.dataset.variantId, 1);
    }
  });
});
